<div>
  <div id="sidebar-container" class="mt-2 d-none d-md-block sidebar-expanded">
    <div class="mt-4 ml-4 mb-2">
      <div class="row">
        <div class="col-sm-1" style="cursor: pointer; color: #800000">
          <i
            (click)="goBackToMenuSideBar()"
            class="fa fa-arrow-circle-o-left fa-lg"
          ></i>
        </div>
        <div class="col-sm-7 ml-1">
          <span style="color: #800000; font-size: 17px">Libraries</span>
        </div>
        <div
          *ngIf="showAddFolder"
          class="col-sm-1"
          style="cursor: pointer; color: #800000"
          (click)="onModalClick()"
        >
          <i class="fa fa-folder fa-lg"></i>
        </div>
        <!-- <div
          class="col-sm-5"
          style="cursor: pointer; color: #800000; text-decoration: underline"
        >
          <a (click)="onModalClick()">Add Folder </a>
        </div> -->
      </div>
    </div>

    <app-document-folder-menu
      *ngFor="let mainfolder of folderList"
      [mainfolder]="mainfolder"
    >
    </app-document-folder-menu>
  </div>

  <div *ngIf="showOpenModal">
    <app-create-folder
      (modalChanged)="modalChangeValue($event)"
    ></app-create-folder>
  </div>
</div>
